import h from "trader-hyperscript";
import { dyn } from "trader.ts/ui";
import { Form } from "trader.ts/ui.forms";
import * as style from "./../../styles/style.css.classes";
import { typeaheadField } from "./../client/typeaheadfield";
import {
  getFromLocalStorage,
  localStorageSpec,
  setLocalStorage,
} from "./../lib/localstorage";
import { renderCancelButton } from "./savebutton";

export function renderDownloadExampleSection<T>(opts: {
  findOptions: (opts: { searchstring: string }) => Promise<T[]>;
  showOption: (t: T) => string;
  lsSpec: localStorageSpec<T>;
  makeDownloadLink: (t: T) => string;
  inputLabel: string;
  close: () => void;
}) {
  const f = new Form({})
    .addField("item", [], async () => {
      return typeaheadField(opts.findOptions, opts.showOption, {
        maxCandidatesToShow: 5,
        initial: getFromLocalStorage(opts.lsSpec) || null,
        label: opts.inputLabel,
      });
    })
    .build();
  return (
    <div className={style.panel} style="">
      {f.render()}
      {dyn(f.s, (s) => {
        if (s.tag === "parsed") {
          setLocalStorage(opts.lsSpec, s.parsed.item);
          return (
            <div style="text-align: right">
              {renderCancelButton({ onclick: close })}
              <a
                href={opts.makeDownloadLink(s.parsed.item)}
                download={"Voorbeeld" + ".pdf"}
                target="_blank"
                style="margin-left: 8px;"
              >
                <button>{"Download als PDF"}</button>
              </a>
            </div>
          );
        } else {
          return <span></span>;
        }
      })}
    </div>
  );
}
